'use strict';

var Sugar = require('sugar-core');

require('./build/buildClassCheckMethodsCall');

module.exports = Sugar.Object.isString;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/object/isString.js
// module id = 819
// module chunks = 0